import React, { useEffect, useContext, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { Alert, Box, CircularProgress } from '@mui/material'
import { AuthContext } from '../../contexts/auth/authContext'
import { useGetCurrentSession } from '../../services/api-query/auth'
import { useGetCustomer } from '../../services/api-query/customer'
import { analyticsDomain, analyticsCta } from '../../services/constants'
import { sendClickAnalytics } from '../../components/common/util/util'

export default function Impersonate() {
    const auth = useContext(AuthContext)
    const [error, setError] = useState('')
    const [data, setData] = useState({} as any)
    const [searchParams] = useSearchParams();
    const navigate = useNavigate()
    const { refetchSession, currentSession } = useGetCurrentSession()
    const { refetchCustomer } = useGetCustomer(currentSession);

    const impersonate = async (otpData: any, staff?:any) => {
        if(otpData) {
            await auth.signOut()
            if(staff) auth?.setStaff(staff)
            auth.impersonate(otpData.otp, otpData.codeVerifier, otpData.referenceId)
            navigate('/impersonate')
        }
    }

    useEffect(()=>{
        if(auth?.impersonateError) setError(auth?.impersonateError)
        if(auth?.impersonated && !auth?.impersonateError) {
            refetchCustomer()
            .then(()=>{
                sendClickAnalytics('/impersonate', {
                    domain: analyticsDomain.profile,
                    name: analyticsCta.impersonation,
                    metadata: {
                        impersonatedBy: auth?.staff?.split('::')[1] || auth?.staff?.split('::')[0]
                    },
                  })
                navigate('/')
            })
        } else {
            const otp = searchParams.get("otp")
            const staff = searchParams.get("staff")
            const staffName = searchParams.get("staffName")
            if(!otp && !error && !data?.otp) {
                navigate('/')
            } else if(!error) {
                if(!data?.otp) {
                    const otpData = JSON.parse(atob(`${otp}`))
                    if(!otpData?.otp || !otpData?.codeVerifier || !otpData?.referenceId) {
                        navigate('/')
                    }
                    setData(otpData)
                    impersonate(otpData, `${staffName}::${staff}`)
                } else {
                    refetchSession()
                    .then(()=> navigate('/'))
                }
            }
        }
        if(error) {
            setTimeout(()=>{
                navigate('/')
            }, 15000)
        }
    
    },[error, auth?.authStatus, auth?.impersonateError, auth?.impersonated])

    return (
        <Box width="100vw" height="100vh">
            <Box display="flex" flexDirection="row" justifyContent="center">
                <Box display="flex" flexDirection="column" justifyContent="center" height="100vh">
                {error && 
                    <Alert severity='error'>
                       Impersonation failed. Please try again.<br/>
                       {error==='WRONG_OTP_REFERENCE'?'This key has expired.': error}
                    </Alert>
                }
                {!error &&
                    <Box sx={{ display: 'flex' }}>
                        <CircularProgress />
                    </Box>
                }
                </Box>
            </Box>
        </Box>
    )
}